import React from 'react';

import { StepContainer } from '../styles';

interface Props {
  title?: string;
  text?: string;
  iconPath: string;
  marginLeft?: boolean;
  html?: React.ReactElement[];
}

const Step = ({ title, text, iconPath, marginLeft, html }: Props) => (
  <StepContainer>
    <StepContainer.Header>
      <StepContainer.IconArea.Icon marginLeft={marginLeft} src={iconPath} />
    </StepContainer.Header>
    <StepContainer.Step>
      <StepContainer.IconArea>
        <StepContainer.Logo src="/images/travel-4-business-logo.png" />
      </StepContainer.IconArea>
      <StepContainer.TextArea>
        {title && <h4>{title}</h4>}
        {text && <h5>{text}</h5>}
        {html && html}
      </StepContainer.TextArea>
    </StepContainer.Step>
  </StepContainer>
);

export default Step;
